import View from './View.js';
import { ASSETS } from '../config.js';
import previewView from './previewView.js';

class ProductView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Product View Error Message';
  _message = 'Product View Success Message';

  addHandlerSelectSize(parent) {
    const loadEl =
      parent === 'popup' ? this._popupElement : this._parentElement;
    const load = loadEl.addEventListener('click', e => {
      const btnContainer = e.target.closest('.product__size--buttons');

      if (!btnContainer) return;

      const btnCur = e.target.closest('.product__size--btn');
      if (btnCur) {
        const btnSizes = document.querySelectorAll('.product__size--btn');
        btnSizes.forEach(btn => {
          btn.classList.remove('product__size--btn-selected');
        });

        btnCur.classList.add('product__size--btn-selected');
      }
    });
  }

  addHandlerBuyProduct(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const btnBuy = e.target.closest('.product__cta--buy');
      if (!btnBuy) return;

      const size = document.querySelector('.product__size--btn-selected');

      handler(!size ? size : size.dataset.size);
    });
  }

  _generateMarkup() {
    const product = this._data;

    let images =
      product.images.length > 0
        ? product.images.map(
            image => `
                      <div class="product__img">
              <img src="${ASSETS}images/product/${image}" alt="${product.brand}" />
            </div>
          `,
          )
        : `
                      <div class="product__img">
              <img src="${ASSETS}images/product/default-product.jpg" alt="${product.name} by ${product.brand}" />
            </div>
        
        
    `;

    if (product.images.length > 0) images = images.join('');

    let sizes =
      product.sizesAvailable && product.sizesAvailable.length > 0
        ? product.sizesAvailable.map(
            size => `<div class="product__size--button">
                <button
                  class="product__size--btn "
                  data-size="${size}"
                >
                  ${size}
                </button>
              </div>`,
          )
        : `<div class="product__size--button">
                <button
                  class="product__size--btn product__size--btn-selected"
                  data-size="standard"
                >
                  Standard
                </button>
              </div>`;

    if (product.sizesAvailable.length > 0) sizes = sizes.join('');

    let features =
      product.features && product.features.length > 0
        ? product.features.map(
            feature => `<p class="product__feature">${feature}</p>`,
          )
        : '';

    if (product.features.length > 0) features = features.join('');

    let care =
      product.care && product.care.length > 0
        ? product.care.map(
            el => `<p class="product__spec--description">${el}</p>`,
          )
        : '';

    if (product.care.length > 0) care = care.join('');

    let packageContains =
      product.packageContains && product.packageContains.length > 0
        ? product.packageContains.map(
            el => `<p class="product__spec--description">${el}</p>`,
          )
        : '';
    if (product.packageContains.length > 0)
      packageContains = packageContains.join('');

    return `
      <div class="row product__single">
        <div class="product__img--container">
          <div class="product__img--inner">
            ${images}
          </div>
        </div>
        <div class="product__detail--container">

          <div class="product__price--info">
            <h1 class="product__title">${product.brand}</h1>
            <h1 class="product__tag">
              ${product.name}
            </h1>
            <p class="product__price--container">
              <span class="product__price"><strong>₹${product.price}</strong></span>
              
              ${product.mrp && product.mrp - product.price > 0 ? `<span class="product__mrp">MRP <del>₹${product.mrp}</del> </span> <span class="product__discount">(${Math.ceil(((product.mrp - product.price) * 100) / product.mrp)}% OFF)</span>` : ''}

            </p>
            <p class="product__selling-price">
              <span class="product__tax-info"> inclusive of all taxes </span>
            </p>
          </div>
          <div class="product__size--container">
            <div class="product__size--head">
              <h4 class="product__size--title">Select Size</h4>
            </div>
            <div class="product__size--buttons">
              ${sizes}
            </div>
          </div>

          <!-- CTA -->
          <div class="product__cta--container">
 
            ${
              product.inStock
                ? `
              <div class="product__cta--buy">               
                <button class="btn btn--cart product__cta--buy-now">
                  Buy
                </button> 
              </div>              
              `
                : `              
              <div class="product__cta--stock">                
                <button class="btn ">
                  Out of stock
                </button> 
              </div>
              `
            }
          </div>

          <!-- FEATURES -->
          <div class="product__feature--container">
            <div class="product__features"> ${features} </div>
          </div>

          <!-- PRODUCT DETAILS -->
          <div class="product__details">
            <div class="product__details--head">
              <h4 class="product__details--title">Product Details</h4>
            </div>
            <p class="product__details--description">${product.description}

            </p>
            <div class="product__specs">
              <div class="product__spec">
                <h4 class="product__spec--title">Material</h4>
                <p class="product__spec--description">${product.material}</p>
              </div>
              <div class="product__spec">
                <h4 class="product__spec--title">Care</h4>${care}</div>
              <div class="product__spec">
                <h4 class="product__spec--title">Use case</h4>
                <p class="product__spec--description">
                  ${product.useCase}
                </p>
              </div>
              <div class="product__spec">
                  <h4 class="product__spec--title">Package Contains</h4>${packageContains}</div>
              </div>
          </div>
        </div>
      </div>

 
    `;
  }
}

export default new ProductView();
